import customAxios from "./axiosConfig";

const TimerService = {
  start: function (data) {
    var api_url = window.Urls["timer_start_timer"]();
    var headers = {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    };
    return customAxios.post(api_url, data, headers);
  },
  resume: function (data) {
    var api_url = window.Urls["timer_restart_timer"]();
    var headers = {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    };
    return customAxios.post(api_url, data, headers);
  },
  pause: function (data) {
    var api_url = window.Urls["timer_pause_timer"]();
    var headers = {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    };
    return customAxios.post(api_url, data, headers);
  },
  destroyTimer: function (data) {
    var api_url = window.Urls["timer_destroy_timer"]();
    var headers = {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    };
    return customAxios.post(api_url, data, headers);
  },
  changeProject: function (data) {
    var api_url = window.Urls["timer_change_timer_project"]();
    var headers = {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    };
    return customAxios.post(api_url, data, headers);
  },
  getTimers: function (params) {
    var api_url = window.Urls["timer_get_timers"]();
    return customAxios.get(api_url, {params: params});
  },
  getRunningTimer: function (params) {
    var api_url = window.Urls["timer_get_running_timer"]();
    return customAxios.get(api_url, {params: params});
  },
};

export default TimerService;